import { useFormContext } from "react-hook-form";
import { retrieveFieldError } from "../../utils/formHelpers";
import useRequiredRule from "../../utils/useRequiredRule";
import TextField from "./TextField";

const baseSx = {
  "& .MuiInputBase-input": {
    boxShadow: "none !important",
    ":required": {
      boxShadow: "none !important",
    },
  },
};

const defaultInputProps = {
  autoCapitalize: "off",
  autoCorrect: "off",
};

export default function TextAreaField(props) {
  const {
    name,
    label,
    hint,
    registerOptions,
    validate,
    helperText,
    sx,
    inputProps: inputPropsProp,
    ...rest
  } = props;

  const {
    register,
    formState: { errors },
  } = useFormContext();

  const error = retrieveFieldError(name, errors);
  const rules = useRequiredRule(rest.required, registerOptions);
  const fieldProps = register(name, { ...rules });

  const inputProps = {
    ...defaultInputProps,
    ...inputPropsProp,
  };

  return (
    <TextField
      {...fieldProps}
      {...rest}
      sx={{ ...baseSx, ...sx }}
      label={label}
      multiline
      fullWidth
      error={!!error}
      helperText={hint || helperText}
      autoComplete="off"
      inputProps={inputProps}
    />
  );
}
